import React, { useState, forwardRef } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Input } from './Input'; // Kendi Input bileşenimizi kullanıyoruz

// InputProps'u Input bileşeninden alıyoruz ama type'ı dışarıda bırakıyoruz
interface PasswordInputProps extends Omit<React.ComponentProps<typeof Input>, 'type'> {}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  (props, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
      <div className="relative">
        <Input
          {...props}
          ref={ref}
          type={showPassword ? 'text' : 'password'}
          // Padding-right ekleyerek ikonun yazı üzerine binmesini engelliyoruz
          className={`pr-10 ${props.className || ''}`}
        />
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute right-3 top-9 text-gray-400 hover:text-gray-600 transition focus:outline-none"
          // Label varsa top değerini ayarlamak gerekebilir, 
          // ancak standart Input yapımızda ikon ortalaması için top-9 (label+input) yaklaşık değerdir.
          // Eğer label yoksa top-2.5 daha uygun olur. 
          // Bu örnekte Label'lı kullanıma göre optimize edilmiştir.
          style={{ top: props.label ? '34px' : '10px' }} 
          tabIndex={-1}
        >
          {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
        </button>
      </div>
    );
  }
);

PasswordInput.displayName = 'PasswordInput';